import { useCancelMerchantAccessMutation } from "Api/Mutations/Merchants/useCancelMerchantAccessMutation";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useState } from "react";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Hunter.Merchants.Detail;
const COMMON = Resources.Common;

type Props = {
  merchantUserLogin: string;
  merchantPublicID: string;
};

export const CancelAccessButton = ({
  merchantUserLogin,
  merchantPublicID,
}: Props) => {
  const { t } = useResource();
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const { mutate, isPending } = useCancelMerchantAccessMutation({
    onSuccess: () => setIsConfirmOpen(false),
  });

  const handleConfirm = () => {
    if (!isPending) {
      mutate({ merchantPublicID });
    }
  };

  return (
    <>
      <Button
        variant="outlined"
        color="error"
        size="small"
        onClick={() => setIsConfirmOpen(true)}
        endIcon={<CancelIcon />}
      >
        {t(RESOURCES.CancelAccessButton)}
      </Button>

      <Dialog open={isConfirmOpen} onClose={() => setIsConfirmOpen(false)}>
        <DialogTitle>{t(RESOURCES.CancelAccessConfirmTitle)}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t(RESOURCES.CancelAccessConfirmBody, {
              userLogin: merchantUserLogin,
            })}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsConfirmOpen(false)} disabled={isPending}>
            {t(COMMON.Back)}
          </Button>
          <Button
            onClick={handleConfirm}
            color="error"
            variant="contained"
            disabled={isPending}
            endIcon={isPending ? <CircularProgress size={16} /> : undefined}
          >
            {t(COMMON.Confirm)}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
